import withCx, { CxProps } from 'fe-core/util/withCx';
import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';
import Badge, { BadgeVariant } from 'fe-design-base/molecules/Badge';

export interface TabItemProps {
  value: string | number;
  label: string | JSX.Element;
  iconName?: 'Warning' | 'Critical';
  badgeText?: number | string;
  badgeVariant?: BadgeVariant;
  disabled?: boolean;
}

const TabItem = ({
  cxEl,
  label,
  disabled,
  iconName,
  badgeText,
  badgeVariant = 'loud',
}: TabItemProps & CxProps) => (
  <Box row className={cxEl('labelOuterContainer')}>
    <Box className={cxEl('labelInnerContainer')}>
      <Text component="div" variant="body">
        {label}
      </Text>
    </Box>
    {iconName && !badgeText && (
      <Box vcenter>
        <Icon
          iconName={iconName}
          size="small"
          color={iconName === 'Critical' ? 'error300' : 'warning300'}
        />
      </Box>
    )}
    {badgeText && (
      <Box vcenter ml={8}>
        <Badge text={badgeText} variant={badgeVariant} disabled={disabled} />
      </Box>
    )}
  </Box>
);

export default withCx<TabItemProps>('FDBTabs')(TabItem);
